import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import { chooseDBTranslation } from 'utils/translations'
import { ITermsAndPolicy } from 'types/termsAndPolicyInterfaces'
import { termsAndPolicyApi } from 'api/TermsAndPolicyAPI'
import BackButton from 'Components/reusable/IconButtons/BackButton'
import { useTranslation } from 'react-i18next'
import { useNavigate, NavigationType, useNavigationType, useLocation } from 'react-router'
import LoadingIndicator from 'Components/reusable/LoadingIndicator'

/**
 * Renders the TermsAndPolicyModal component.
 *
 * @return {React.ReactElement} The rendered TermsAndPolicyModal component.
 * @notExported
 */
const TermsAndPolicyModal = () => {
  const navigate = useNavigate()
  const navType: NavigationType = useNavigationType()
  const { i18n } = useTranslation()
  const [termsAndPolicies, setTermsAndPolicies] = useState<ITermsAndPolicy[]>()
  const [item, setItem] = useState<ITermsAndPolicy>()
  const [loading, setLoading] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const controller = new AbortController()

    ;(async () => {
      try {
        setLoading(true)

        const data = await termsAndPolicyApi.getGlobalTermsAndPolicies(controller)
        setTermsAndPolicies(data)
        if (data.length) {
          if (location.pathname.includes('terms')) {
            setItem(data[1])
          } else {
            setItem(data[0])
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    })()

    return () => {
      controller.abort()
    }
  }, [location.pathname])

  if (loading) {
    return <LoadingIndicator />
  }

  if (termsAndPolicies && item) {
    return (
      <Dialog open fullWidth maxWidth="xl">
        <DialogTitle>
          <>{navType !== 'POP' && <BackButton clickAction={() => navigate(-1)} />}</>
        </DialogTitle>
        <DialogContent style={{ minHeight: '80vh' }}>
          <Typography>
            <ReactMarkdown>{chooseDBTranslation(i18n, item).content}</ReactMarkdown>
          </Typography>
        </DialogContent>
      </Dialog>
    )
  } else {
    return <></>
  }
}

export default TermsAndPolicyModal
